import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const PhoneNumberSchema = z.string().trim().min(1).max(40).refine(isValidPhoneNumber, {
  message: 'Invalid phone number',
});

export const LoginInputSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
});

export const RefreshInputSchema = z.object({
  refreshToken: z.string().min(1),
});

export const SwitchTenantInputSchema = z.object({
  tenantSlug: z.string().min(1),
});

export const CustomerRegisterSchema = z.object({
  redirectTo: z.string().startsWith('/').max(2048).optional(),
  email: z.string().email(),
  password: z.string().min(8),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: PhoneNumberSchema,
  referralCode: z.string().trim().min(3).max(32).optional(),
});

export const EmailVerificationConfirmSchema = z.object({ token: z.string().min(1).max(256) });
export const EmailVerificationResendSchema = z.object({
  email: z.string().email(),
  redirectTo: z.string().startsWith('/').max(2048).optional(),
});
export interface RegistrationResponse { requiresEmailVerification: true; email: string; }

export const EmailLookupSchema = z.object({
  email: z.string().email(),
});

export const PasswordResetRequestSchema = z.object({
  email: z.string().email(),
});

export const PasswordResetConfirmSchema = z.object({
  token: z.string().min(1),
  password: z.string().min(8),
});

export const SetInitialPasswordInputSchema = z.object({
  password: z.string().min(8),
});

export const UpdateAccountProfileSchema = z.object({
  firstName: z.string().trim().max(100).nullable().optional(),
  lastName: z.string().trim().max(100).nullable().optional(),
  phone: PhoneNumberSchema.nullable().optional(),
  marketingEmailEnabled: z.boolean().optional(),
});

export const MagicLinkRequestSchema = z.object({
  email: z.string().email(),
  redirectTo: z.string().startsWith('/').optional(),
  phone: PhoneNumberSchema.optional(),
});

export const MagicLinkVerifySchema = z.object({
  token: z.string().min(1),
});

export type CustomerRegisterInput = z.infer<typeof CustomerRegisterSchema>;
export type PasswordResetRequest = z.infer<typeof PasswordResetRequestSchema>;
export type PasswordResetConfirm = z.infer<typeof PasswordResetConfirmSchema>;
export type SetInitialPasswordInput = z.infer<typeof SetInitialPasswordInputSchema>;
export type LoginInput = z.infer<typeof LoginInputSchema>;
export type RefreshInput = z.infer<typeof RefreshInputSchema>;
export type SwitchTenantInput = z.infer<typeof SwitchTenantInputSchema>;
export type UpdateAccountProfileInput = z.infer<typeof UpdateAccountProfileSchema>;
export type MagicLinkRequest = z.infer<typeof MagicLinkRequestSchema>;
export type MagicLinkVerify = z.infer<typeof MagicLinkVerifySchema>;
